function initializeNotifyMeFeature() {
    const notifyMeButton = document.getElementById('notify-me');
    const notifyMePopup = document.getElementById('notifyme-popup');
    const notifyMeCloseButton = notifyMePopup.querySelector('.product-form__notifyme-close');
    const notifyMeOverlay = notifyMePopup.querySelector('.product-form__notifyme-overlay');
    const notifyMeForm = document.getElementById('notify-me-form');
    const emailInput = document.getElementById('notify-me-email');
    const successMessageDiv = notifyMePopup.querySelector('.product-form__notifyme-success');
    const errorMessageDiv = notifyMePopup.querySelector('.invalid-feedback');
    const submitButton = notifyMeForm.querySelector('button[type="submit"]');

    const variant = currentVariantID;

    // Function to open the popup
    function openPopup() {
        notifyMePopup.style.display = 'block';
    }

    // Function to close the popup
    function closePopup() {
        notifyMePopup.style.display = 'none';
    }

    if (notifyMeButton) {
        // Event listener for the "Notify Me" button
        notifyMeButton.addEventListener('click', openPopup);

        // Event listeners for the close button and overlay
        notifyMeCloseButton.addEventListener('click', closePopup);
        notifyMeOverlay.addEventListener('click', closePopup);
    }


    // Function to handle form submission
    function handleFormSubmit(event) {
        event.preventDefault();
        const email = emailInput.value;

        successMessageDiv.style.display = 'none';
        errorMessageDiv.style.display = 'none';

        if (email && variant) {
            submitNotifyMe(email, variant)
                .then((data) => {
                    successMessageDiv.style.display = 'block';
                    emailInput.value = '';
                    submitButton.disabled = true;
                })
                .catch((error) => {
                    errorMessageDiv.style.display = 'block';
                });
        } else {
            errorMessageDiv.style.display = 'block';
        }
    }

    // Attach form submit event listener
    notifyMeForm.addEventListener('submit', handleFormSubmit);
}



function submitNotifyMe(email, variant) {
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicApiKey}`;

    const options = {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'revision': '2024-02-15',
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    channels: ['EMAIL'],
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: 'catalog-variant',
                            id: `$shopify:::$default:::${variant}`
                        }
                    }
                }
            }
        })
    };

    return fetch(url, options)
        .then(response => {
            return response.ok;
        });
}